const getSite = (rootState) => rootState.ws.site;

export default getSite;
